    import React, { createRef, useState, useEffect } from "react"
    import { useStaticQuery, graphql } from "gatsby"
    import { Box } from "@sqymagma/elements"
    import { navigationData, getNavigationData } from "../../data/navigationData"
    import Header from "./Header"
    import Menu from "./Menu"
    import MenuCalendar from "./MenuCalendar"


    export default ({ path, calendarOpen, openCalendarMenu}) => {
    
    // get build time
    const query = useStaticQuery(graphql`
        query {
            site {
                buildTime
            }
        }
    `)
    
    const [ menuVars, setMenuVars ] =  useState(null);
    // vars of menu
    useEffect(() => {
        let buildTime = new Date(query.site.buildTime)
        let formatedBuildTime = buildTime.toLocaleDateString();

        const navTextColor = getNavigationData(path) ? getNavigationData(path)["textColor"] : "text01"
        const navBgColor = getNavigationData(path) && getNavigationData(path)["color"] 
        const navTextLink = getNavigationData(path)["text"]

        setMenuVars({
            navTextColor, 
            navBgColor, 
            navTextLink, 
            lastUpdate: formatedBuildTime
        })
        
    }, [path, query.site.buildTime])


    //sticky behaviour
    const [isSticky, setIsSticky] = useState(false)
    const ref = createRef()

    useEffect(() => {
        const cachedRef = ref.current,
        observer = new IntersectionObserver(
            ([e]) => {
            setIsSticky(e.intersectionRatio < 1)
            },
            { threshold: [1] }
        )

        observer.observe(cachedRef)

        return function() {
        observer.unobserve(cachedRef)
        }
    }, [ref])

    const isChronologyPage = path.includes(navigationData[0].link)
    const [isCalendarMenuOpen, setIsCalendarMenuOpen] = useState(false)

    const toggleCalendarMenu = () => {
        setIsCalendarMenuOpen(!isCalendarMenuOpen)
    }

    const closeCalendarMenu = () => {
        setIsCalendarMenuOpen(false)

        if (calendarOpen) {
            openCalendarMenu()
        }
    }


    // useEffect(() => alert(calendarOpen),[calendarOpen])


    return (
        <Box as="section" position="sticky" top="-1px" zIndex="3" ref={ref} mb="-5px">
          { menuVars && (
        <Box
            position="relative"
            css={
            isSticky &&
            `{
                cursor: pointer
                &:hover nav{
                    bottom: -34px
                }
            }`
            }
        >
            <Header
                path={path}
                isSticky={isSticky}
                menuVars={menuVars}
            />
            <Menu

                path={path}
                isSticky={isSticky}
                navTextColor={menuVars.navTextColor}
                navBgColor={menuVars.navBgColor}
                toggleCalendarMenu={toggleCalendarMenu}
                closeCalendarMenu={closeCalendarMenu}
                isChronologyPage={isChronologyPage}
            />
            <MenuCalendar
                toggleCalendarMenu={toggleCalendarMenu}
                closeCalendarMenu={closeCalendarMenu}
                isCalendarMenuOpen={isCalendarMenuOpen}
                navTextColor={menuVars.navTextColor}
                navBgColor={menuVars.navBgColor}
                calendarOpenFromIcon={calendarOpen}
            />
        </Box>
       )}
        </Box>
    )
    }
